import { MutationTree } from 'vuex'
import { State } from './state'
import { RenderingMutationTypes as MutationTypes } from './mutation-types'

export type Mutations<S = State> = {
  [MutationTypes.SET_CAMERA_POS](state: S, payload: number): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_CAMERA_POS](state: State, payload: number) {
    state.cameraPos = payload
    log(MutationTypes.SET_CAMERA_POS, payload)
  }
}

const log = (mut: MutationTypes, msg: any) => {
  // console.log(mut + ' ' + msg)
}

